// initializing 
(function() {
  $(document).ready(function() {
    $(document).on("swell:setup", function() {
      console.log('swell-0');
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Campaign.authenticate();
      SwellConfig.Campaign.appendReferralImage(".swell-campaign-list");
      console.log('swell');console.log('swell-1');
      Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      $(".swell-plae-post-checkout").show();
      SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
      $(".big-spinner").hide();

      if(window.location.href.indexOf("checkouts") > -1 && spapi.isMobile) {
        $(".order-summary-toggle").trigger("click");
        $("input[name='checkout[reduction_code]'").closest('.section--reductions.hidden-on-desktop').hide();
      }
    });

    $(document).on("swell:redemption", function(){
      if(window.location.href.indexOf("checkouts") > -1 && spapi.isMobile) {
        setTimeout(function(){
          $("input[name='checkout[reduction_code]'").closest('.section--reductions.hidden-on-desktop').hide();
        }, 3000);
      }
    });

    $(".swell-referral-back-link").click(function(e){
      $(".swell-plae-post-checkout").hide();
    });

    $(".swell-account-rewards").click(function(e){
      $(".swell-account-reward-page").css("display", "inline");
      $(".swell-account-page").hide();
    });

    $(".swell-account-btn").click(function(e){
      $(".swell-account-reward-page").hide();
      $(".swell-account-page").show();
    });

    $(".tier-arrows .left-arrow").click(function() {
      var first = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;
      var starting_index = 2;

      for(counter = starting_index; counter <= length; counter++) {
        if(!$(".swell-tier-table tr th:nth-child("+counter+")").hasClass("swell-hidden")) {
          if(counter == starting_index) {
            first = true;
          }
          break;
        }
      }

      if(first== true) {
        $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr th:nth-child("+(counter+2)+")").removeClass("swell-hidden");

        $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr td:nth-child("+(counter+2)+")").removeClass("swell-hidden");
      } else {
        $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr th:nth-child("+(counter-1)+")").removeClass("swell-hidden");

        $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr td:nth-child("+(counter-1)+")").removeClass("swell-hidden");
      }
    });

    $(".tier-arrows .right-arrow").click(function() {
      var last = false;
      var length = $(".swell-tier-table thead tr:nth-child(1) th").length;
      var starting_index = 2;

      for(counter = starting_index; counter <= length; counter++) {
        if(!$(".swell-tier-table tr th:nth-child("+counter+")").hasClass("swell-hidden")) {
          if(counter == length) {
            last = true;
          }
          break;
        }
      }

      if(last== true) {
        $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr th:nth-child("+(counter-2)+")").removeClass("swell-hidden");

        $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr td:nth-child("+(counter-2)+")").removeClass("swell-hidden");
      } else {
        $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr th:nth-child("+(counter+1)+")").removeClass("swell-hidden");

        $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-hidden");
        $(".swell-tier-table tr td:nth-child("+(counter+1)+")").removeClass("swell-hidden");
      }
    });

    $(document).on("swell:referral:success", function() {
      swellAPI.refreshCustomerDetails(function() {
        SwellConfig.Referral.populateReferrals(".swell-referral-table .table-data");
      });
    });

    $(document).on("swell:referral:error", function(jqXHR, textStatus, errorThrown) {
      var errorMessage = "Oops! Looks like this person has already made a purchase. Try referring another friend.";
      if (!(textStatus && textStatus === "EMAILS_ALREADY_PURCHASED")) {
        errorMessage = textStatus;
      }
      $(".swell-referral-form-field-details").text(errorMessage);
    });

    $(document).on('click', '.swell-share-referral-copy', function(){
      setTimeout(function() { 
        var referral_copy = $(".swell-referral-copy").detach();
        $(".swell-referral").prepend(referral_copy);
        referral_copy.css("display", "flex");
      }, 10);
    });

    $(document).on('click', '.swell-referral-form-list-submit', function() {
      if($(".swell-referral-register .swell-referral-form-list-field-input").val() == '') {
        $(".swell-referral-form-list-field").append("<span class='swell-referral-form-field-details'>Please provide your email.</span>");
      }
    });

  });
}).call(this);

// campaigns
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Campaign = {
    opts: {
      templates: {
        campaign: "<li class='swell-campaign'>  <div class='swell-campaign-content' data-display-mode='modal'   data-campaign-id='<%= campaign.id %>'>  <div class='swell-campaign-icon'>      <span class='swell-campaign-icon-content'><i class='fa <%= campaign.icon %>'></i></span>    </div>    <div class='swell-campaign-value'>      <span class='swell-campaign-value-content'><%= campaign.reward_text %></span>    </div>    <div class='swell-campaign-type'>      <span class='swell-campaign-type-content'><%= campaign.title %></span>    </div>  </div></li>",
        campaignHover: "<div class='hover-block'> <div class='holder'><div class='icon'><i class='icon-account1'></i></div> <ul class='swell-link-list'> <li class='swell-link'> <a class='login-btn' href='/account/login'>LOG IN</a> </li> <li class='swell-link or-tag'> <span>-or-</span> </li> <li class='swell-link'> <a class='sign-up-btn' href='/account/register'>JOIN NOW</a> </li> </ul> </div> </div>"
      }
    },
    authenticate: function() {
      if(spapi.authenticated) {
        $(".swell-campaign").css("cursor", "pointer");
      } else {
        return $(".swell-campaign-content").hover(function() {
          return $(this).append(SwellConfig.Campaign.opts.templates.campaignHover);
        }, function() {
          return $(this).find(".hover-block").remove();
        });
      } 
    },
    appendReferralImage: function(containerSelector) { 
      var url = '//plae.co/cdn/shop/t/56/assets/refer-block-img.png?v=40418527809124977161786491559'
      $(containerSelector).append("<li class='refer-campaign-list'> <div class='holder'> <div class='deatils-holder'> <h3>Refer Friends and Earn Points</h3> <p>Refer friends and earn $20 in points. <a href='/pages/refer'>Start referring here.</a> </p> </div> <div class='image-holder'><img class='swell-campaign-image-content' src=" + url + " alt='Swell Refer'></li> </div> </div> </li>");
    }
  };
}).call(this);

// referral
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "<span>Refer a Friend</span>Give 20%, Get $30!",
        referralRegisterFormDetails: "Please submit your email below to get started.",
        referralRegisterFormEmail: "your email address",
        referralRegisterFormSubmit: "NEXT",
        referralRegisterDetails: "<%= referralCampaign.details %>",

        referralReferHeading: "<span>Refer a Friend</span>Give 20%, Get $30!",
        referralReferFormEmails: "your friends' emails (separated by commas)",
        referralReferFormSubmit: "SEND",
        referralReferFormDetails: "Now, enter your friends' emails below.",
        referralReferFormEmailsDetails: "",
        referralReferDetails: "<%= referralCampaign.details %>",

        referralReferMediaDetails: "You can also share your link with the buttons below",

        referralShareFacebook: "Share",
        referralShareTwitter: "Twitter",
        referralShareCopy: "Copy Link",

        referralFacebookIcon: "icon-facebook",
        referralTwitterIcon: "icon-twitter2",
        referralLinkIcon: "icon-link",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy link and share with your friends"
      },
      templates: {
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"><%= localization.referralReferDetails %></p> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralReferFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> <span class="swell-referral-form-field-details"><%= localization.referralReferFormEmailsDetails %></span> </li> </ul> </div> <div class="swell-referral-form-footer"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </div> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"><%= localization.referralReferMediaDetails %></p> <ul class="swell-referral-media-list">  <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon icon-messenger" aria-hidden="true"></i>&nbsp;Share </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon icon-sms" aria-hidden="true"></i>&nbsp;SMS </div> </li> <li class="swell-referral-medium swell-share-referral-twitter"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralTwitterIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareTwitter %> </div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>'
      }
    },
    populateReferrals: function(containerSelector) {
      if (spapi.authenticated) {
        referral_receipts = spapi.customer.referral_receipts;

        $(".swell-plae-refer .redeem-holder").removeClass("swell-hidden");
        var referrals = {};

        $.each(referral_receipts, function( index, item ) {
          status = "Invited";
          if (item.completed_at != null) {
            status =  "<span>Purchased" + " (" + spapi.activeReferralCampaign.reward_text + " earned" + ")</span>";
          }
          referrals += "<tr><td class='swell-td'>" + item.email + "</td><td class='swell-td'>" + status + "</td></tr>";
        });

        $(containerSelector).html(referrals);
      }
    }
  };
}).call(this);

// Tiers 
(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Tier = {
    getCustomerTierId: function() {
      var customer_tier, intro_tier, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier) {
        return customer_tier.id;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].id;
        } else {
          return null;
        }
      }
    },
    getCustomerTierRank: function() {
      var customer_tier, intro_tier, rank, tiers;
      customer_tier = spapi.customer.vip_tier;
      tiers = spapi.activeVipTiers;
      if (customer_tier && customer_tier.id) {
        rank = $.grep(tiers, function(e) {
          return e.id === customer_tier.id;
        })[0].rank;
        return rank;
      } else {
        intro_tier = $.grep(tiers, function(e) {
          return e.swellrequiredAmountSpent === "$0" && e.swellrequiredAmountSpentCents === 0 && e.swellrequiredPointsEarned === 0 && e.swellrequiredPurchasesMade === 0 && e.swellrequiredReferralsCompleted === 0;
        });
        if (intro_tier.length > 0) {
          return intro_tier[0].rank;
        } else {
          return null;
        }
      }
    },
    getTierByRank: function(rank) {
      var tiers;
      tiers = spapi.activeVipTiers;
      return $.grep(tiers, function(e) {
        return e.rank === rank;
      })[0];
    },
    setupCustomerTierStatus: function() {
      var  columnLength, customer_tier_id, customer_tier_rank, data_id, next_tier, current = 2;

      customer_tier_id = SwellConfig.Tier.getCustomerTierId();
      customer_tier_rank = SwellConfig.Tier.getCustomerTierRank();
      
      if(customer_tier_id) {
        next_tier = SwellConfig.Tier.getTierByRank(customer_tier_rank + 1);
      } else {
        next_tier = SwellConfig.Tier.getTierByRank(1);
      }
      columnLength = $(".swell-tier-table .swell-tier-values").children().length;
      $(".swell-tier-table thead").prepend("<tr class='swell-tier-status-row'><th scope='row'></th><th scope='col'></th><th scope='col'></th><th scope='col'></th></tr>");

      if (customer_tier_id === spapi.activeVipTiers[spapi.activeVipTiers.length - 1].id) {
        $(".swell-tier-table .swell-tier-status-row th:nth-child("+columnLength+")").prepend("<span class='current-status'>Current Status <span class='arrow-down'></span></span>");
        $(".swell-tier-table tr th:nth-child("+columnLength+")").addClass("swell-current-status");
        $(".swell-tier-table tr td:nth-child("+columnLength+")").addClass("swell-current-status");
        current = columnLength;
      } 
      else { 
        for(counter = 2; counter<columnLength; counter++) {
          data_id = $(".swell-tier-table .swell-tier-values th:nth-child("+counter+")").data("tierId");
          if(data_id == customer_tier_id) {
            $(".swell-tier-table .swell-tier-status-row th:nth-child("+counter+")").prepend("<span class='current-status'>Current Status <span class='arrow-down'></span></span>");
            $(".swell-tier-table .swell-tier-status-row th:nth-child("+(counter+1)+")").prepend("<span class='next-status'>Earn "+ (next_tier.points_earned - swellAPI.getCustomerDetails().vipTierStats.pointsEarned)  + " points to level up</span>");
            $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-current-status");
            $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-current-status");
            current = counter;
          }        
        }
      }

      if(!customer_tier_id) {
        $(".swell-tier-table .swell-tier-status-row th:nth-child(2)").prepend("<span class='current-status'>Current Status <span class='arrow-down'></span></span>");
        if(swellAPI.getCustomerDetails().vipTierStats) {
         $(".swell-tier-table .swell-tier-status-row th:nth-child(3)").prepend("<span class='next-status'>Earn "+ (next_tier.points_earned - swellAPI.getCustomerDetails().vipTierStats.pointsEarned)  + " points to level up</span>");
        } else {
         $(".swell-tier-table .swell-tier-status-row th:nth-child(3)").prepend("<span class='next-status'>Earn "+ spapi.activeVipTiers[1].prettyAmountSpent +" to level up</span>");
        }
        $(".swell-tier-table tr th:nth-child(2)").addClass("swell-current-status");
        $(".swell-tier-table tr td:nth-child(2)").addClass("swell-current-status");
      }

      return current;
    },
    referralTableOnMobile: function(current) {
      var  columnLength = $(".swell-tier-table .swell-tier-values").children().length;
      for(counter=2; counter <= columnLength; counter++) {
        if(counter!=current) {
          $(".swell-tier-table tr th:nth-child("+counter+")").addClass("swell-hidden");   
          $(".swell-tier-table tr td:nth-child("+counter+")").addClass("swell-hidden");   
        }
      }
    },
    initializeDummyTier: function() {
      var k, len, tier, tiers;
      tiers = spapi.activeVipTiers;
      for (k = 0, len = tiers.length; k < len; k++) {
        tier = tiers[k];
        tier.rank += 1;
      }
      return tiers.unshift({
        id: -1,
        rank: 0,
        name: "Tier 1",
        points_multiplier: "1X",
        standard_products: "",
        free_shipping: "",
        early_access_sales: "",
        exclusive_products: "",
        swellrequiredAmountSpentCents: 0,
        swellrequiredPointsEarned: 0,
        swellrequiredPurchasesMade: 0,
        swellrequiredReferralsCompleted: 0
      });
    },
    initializeCustomTierProperties: function() {
      var tier_0_upper_range = (spapi.activeVipTiers[1].points_earned) - 1;
      var tier_1_upper_range = (spapi.activeVipTiers[2].points_earned) - 1;

      spapi.activeVipTiers[0].points ="Earn 0&ndash;"+tier_0_upper_range+" Points";
      spapi.activeVipTiers[0].standard_products = "<i class='icon-star' aria-hidden='true'></i>";

      spapi.activeVipTiers[1].points = "Earn "+spapi.activeVipTiers[1].points_earned + "&ndash;" + tier_1_upper_range+ " Points";
      spapi.activeVipTiers[1].points_multiplier = spapi.activeVipTiers[1].points_multiplier + "X";
      spapi.activeVipTiers[1].standard_products = "<i class='icon-star' aria-hidden='true'></i>";
      spapi.activeVipTiers[1].free_shipping = "Standard";
      spapi.activeVipTiers[1].early_access_sales = "<i class='icon-star' aria-hidden='true'></i>";
      spapi.activeVipTiers[1].exclusive_products = "";

      spapi.activeVipTiers[2].points = "Earn "+spapi.activeVipTiers[2].points_earned+"+ Points";
      spapi.activeVipTiers[2].points_multiplier = spapi.activeVipTiers[2].points_multiplier + "X";
      spapi.activeVipTiers[2].standard_products = "<i class='icon-star' aria-hidden='true'></i>";
      spapi.activeVipTiers[2].free_shipping = "2-Day Shipping";
      spapi.activeVipTiers[2].early_access_sales = "<i class='icon-star' aria-hidden='true'></i>";
      spapi.activeVipTiers[2].exclusive_products = "<i class='icon-star' aria-hidden='true'></i>";
    },
    initializeTiers: function(containerSelector) {
      var i, j, key, properties, property, ref, ref1, tiers, current_tier = 2;
      if ($(containerSelector).length === 0) {
        return "";
      }
      tiers = spapi.activeVipTiers;
      properties = {
        header: {
          points: {
            className: "swell-tier-values",
            title: ""
          },
          name: {
            className: "swell-tier-names",
            title: "Benefits"
          }
        },
        body: {
          points_multiplier: {
            title: "Multiplier"
          },
          standard_products: {
            title: "Standard Products To Redeem"
          },
          free_shipping: {
            title: "Free Shipping"
          },
          early_access_sales: {
            title: "Early Access To Sales"
          },
          exclusive_products: {
            title: "Exclusive Products To Redeem  - Coming soon!"
          }
        }
      };
      $(containerSelector).append("<thead></thead>");
      $(containerSelector).append("<tbody></tbody>");
      j = 0;
      ref = properties.header;
      for (key in ref) {
        property = ref[key];
        $(containerSelector).find("thead").append("<tr class='" + property.className + "'>  <th scope='row'>" + property.title + "</th></tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("thead tr:eq(" + j + ")").append("<th scope='col' data-tier-id='" + tier.id + "'>" + tier[key] + "</th>");
        });
        j++;
      }
      i = 0;
      ref1 = properties.body;
      for (key in ref1) {
        property = ref1[key];
        $(containerSelector).find("tbody").append("<tr> <th scope='row'>" + property.title + "</th></tr>");
        tiers.forEach(function(tier) {
          return $(containerSelector).find("tbody tr:eq(" + i + ")").append("<td data-tier-id='" + tier.id + "'>" + tier[key] + "</td>");
        });
        i++;
      }
      if (spapi.authenticated) {
        current_tier = SwellConfig.Tier.setupCustomerTierStatus();
      }
      if(spapi.isMobile) {
        return SwellConfig.Tier.referralTableOnMobile(current_tier);
      }
    }
  };
}).call(this);
